// Vendors
import React from 'react';

// Components
import { Trans } from '../../../components/common';
import ServiceIcon from '../../../components/common/ServiceIcon/ServiceIcon';
import SummaryCard from '../../../components/common/Cards/SummaryCard/SummaryCard';

// PRJ1417943_IntergrationAccelerator - Separated from UnlinkServiceModal for reusability and agency-specific props: account, agency, modalLicenseNumber
const TDLRSummaryCard = ({ account, modalLicenseNumber }) => {
  // Only render if account license number matches the selected license number from modal
  if (
    !account.licenseNumber ||
    !modalLicenseNumber ||
    account.licenseNumber !== modalLicenseNumber
  ) {
    return null;
  }

  return (
    <SummaryCard
      key={account.licenseNumber}
      className="card-flat"
      outlined={false}
      graphic={<ServiceIcon type="professional-license" />}
      horizontalList={true}
    >
      <SummaryCard.List
        items={[
          {
            label: (
              <Trans file="Labels" id="LicenseType" fallback="LicenseType" />
            ),
            value: account.licenseType,
          },
          {
            label: (
              <Trans
                file="Labels"
                id="LicenseNumber"
                fallback="LicenseNumber"
              />
            ),
            value: account.licenseNumber,
          },
        ]}
      />
    </SummaryCard>
  );
};

export default TDLRSummaryCard;
